module.exports = __webpack_public_path__ + "static/images/monet/decimal_field.png";